<template>
  <div class="process">
    <div class="process-box">
      <div class="process-content">
        <div class="process-content-left">
          <div class="process-content-one">专家顾问\ 专业团队\系统规范</div>
          <div class="process-content-two">全流程征收服务</div>
          <div
            class="process-content-four"
            style=" margin-top: 30px;"
          >由政府引导 + 群众参与 + 第三方市场化运作 = 确保高效公开</div>
          <div class="process-content-four">公正易征模式采取综合型组织结构 ， 保留传统组织结构下的优</div>
          <div class="process-content-four">势 ， 规避不足，民主协商、科学决策、阳光征收。</div>
        </div>
        <div class="process-content-right">
          <img src="../assets/img/quanliucheng_0111.png" />
        </div>
      </div>
    </div>
    <div class="process-content-box">
      <div class="process-one">
        <div class="process-one-left" id="wrapper-text">
          <div class="process-text-one">专家顾问团队</div>
          <div class="process-text-two">Expert Advisory</div>
          <div class="process-text-three" style="margin-top:30px">云征收联盟组成的专家团队顾问，致力解决各地</div>
          <div class="process-text-three">征收难题。各方协调收集整理分析数据，制定政</div>
          <div class="process-text-three">策分析难点；集体决策技术支持专业指导，谈判</div>
          <div class="process-text-three">依据处理意见</div>
        </div>
        <div class="process-one-right" id="wrapper-img">
          <img src="../assets/img/quanliucheng_02.png" />
        </div>
      </div>
      <div class="process-two">
        <div class="process-one-left" id="wrapper-text1">
          <div class="process-text-one">专业现场人员</div>
          <div class="process-text-two">The specialized talents</div>
          <div class="process-text-three" style="margin-top:30px">现场参与项目工作人员皆为实操、服务过多个项</div>
          <div class="process-text-three">目和区域，熟悉征收，人员严谨细致。</div>
        </div>
        <div class="process-one-right" id="wrapper-img1">
          <img src="../assets/img/quanliucheng_03.png" />
        </div>
      </div>
      <div class="process-three">
        <div class="process-one-left" id="wrapper-text2">
          <div class="process-text-one">使用系统：规范、高效</div>
          <div class="process-text-two">Using the systems</div>
          <div class="process-text-three" style="margin-top:30px">使用自主研发的征拆信息化系统：有效提高征收</div>
          <div class="process-text-three">效率、规范流程。</div>
        </div>
        <div class="process-one-right" id="wrapper-img2">
          <img src="../assets/img/quanliucheng_04.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight process-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft process-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight process-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft process-one-left'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight process-one-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft process-one-left'
    );
  }
};
</script>
<style>
.process {
  width: 100%;
}
.process-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.process-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.process-content-left {
  margin-top: 70px;
  width: 50%;
}
.process-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.process-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.process-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.process-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.process-content-right {
  width: 50%;
}
.process-content-right img {
  /* margin-top: 20px; */
  width: 100%;
}
.process-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.process-one,
.process-two,
.process-three {
  display: flex;
  height: 500px;
  padding: 0 80px;
  overflow: hidden;
}
.process-text-one {
  margin-top: 96px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: rgb(73, 83, 98);
}
.process-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 30px;
  color: #999999;
}
.process-text-three {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.process-one-left, .process-one-right{
  width: 50%;
}
.process-one-right img {
  width: 100%;
  margin-top: 50px;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .process-content,
  .process-content-box {
    width: 1200px !important;
  }
  .process-content-two {
    font-size: 48px !important;
  }
  .process-one-left {
    padding-right: 30px !important;
  }
  .process-text-one {
    font-size: 36px !important;
  }
  .process-text-two {
    font-size: 28px !important;
  }
  .process-text-three {
    font-size: 24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/full-process-collection.vue